<i18n src="./langset.json"></i18n>
<template>
  <div class="comList-container">
    <!-- 筛选条件区域 -->
    <el-card class="filter-area" v-if="props.formItem.length">
      <el-form
        ref="formRef"
        size="small"
        :model="searchParams"
        label-position="right"
        label-width="auto"
        :rules="props.rules"
        onsubmit="return false;"
      >
        <el-row :gutter="72">
          <el-col
            v-for="(item, index) in props.formItem || []"
            v-show="!filterCollapsed || index < firstRowCount"
            :key="index"
            :span="item.span || 6"
          >
            <el-form-item :label="item.label" :label-width="item.width" :prop="item.prop">
              <template v-if="item.type === 'input'">
                <el-input
                  v-model.trim="searchParams[item.prop]"
                  :disabled="item.disabled || false"
                  :placeholder="item.placeholder || `${t('请输入')}${item.label}`"
                  clearable
                  @input="formaterInputString"
                  @keyup.enter="searchFun"
                >
                  <template #suffix>
                    <el-icon class="el-input__icon" size="10" @click.stop="batchSearchFun(item)">
                      <MoreFilled v-show="item.supportBatchQuery == undefined || item.supportBatchQuery" />
                    </el-icon>
                  </template>
                </el-input>
              </template>
              <template v-else-if="item.type === 'number'">
                <el-input-number
                  v-model="searchParams[item.prop]"
                  :disabled="item.disabled || false"
                  :max="item.max || 100"
                  :min="item.min || 0"
                  clearable
                />
              </template>
              <template v-else-if="item.type === 'select'">
                <async-select
                  v-model="searchParams[item.prop]"
                  :promise-fn="item.optionsPro"
                  :placeholder="item.placeholder || `${t('请选择')}${item.label}`"
                  :disabled="item.disabled || false"
                  v-bind="item.props"
                ></async-select>
              </template>
              <template v-else-if="item.type === 'time'">
                <el-time-select
                  v-model="searchParams[item.prop]"
                  :disabled="item.disabled || false"
                  :end="item.end || '18:00'"
                  :max-time="item.maxTime"
                  :min-time="item.minTime"
                  :placeholder="item.placeholder || `${t('请选择')}${item.label}`"
                  :start="item.start || '08:30'"
                  :step="item.step || '00:30'"
                  clearable
                  format="ss:mm"
                />
              </template>
              <template v-else-if="item.type === 'timerange'">
                <el-time-picker
                  v-model="searchParams[item.prop]"
                  :disabled="item.disabled || false"
                  :end-placeholder="item.endPlaceholder || `${t('请选择结束')}${item.label}`"
                  :range-separator="item.rangeSeparator || '-'"
                  :start-placeholder="item.startPlaceholder || `${t('请选择开始')}${item.label}`"
                  clearable
                  format="HH:mm:ss"
                  is-range
                />
              </template>
              <template v-else-if="['date', 'week', 'month', 'year', 'dates'].includes(item.type)">
                <el-date-picker
                  v-model="searchParams[item.prop]"
                  :disabled-date="item.disabledDate"
                  :format="item.format"
                  :placeholder="item.placeholder || `${t('请选择')}${item.label}`"
                  :shortcuts="item.shortcuts"
                  :time-format="item.timeFormat || 'HH:mm'"
                  :type="item.type"
                  :value-format="item.valueFormat || 'YYYY-MM-DD'"
                />
              </template>
              <template v-else-if="item.type === 'daterange' || item.type === 'monthrange'">
                <el-date-picker
                  v-model="searchParams[item.prop]"
                  :disabled-date="item.disabledDate"
                  :end-placeholder="item.endPlaceholder || `${t('请选择结束')}${item.label}`"
                  :format="item.format || 'YYYY-MM-DD'"
                  :shortcuts="item.shortcuts"
                  :start-placeholder="item.startPlaceholder || `${t('请选择开始')}${item.label}`"
                  :type="item.type"
                  :value-format="item.valueFormat || 'YYYY-MM-DD'"
                />
              </template>
              <template v-else-if="item.type === 'datetime'">
                <el-date-picker
                  v-model="searchParams[item.prop]"
                  :date-format="item.dateFormat || 'YYYY-MM-DD'"
                  :disabled-date="item.disabledDate"
                  :format="item.format"
                  :placeholder="item.placeholder || `${t('请选择')}${item.label}`"
                  :shortcuts="item.shortcuts"
                  :time-format="item.timeFormat || 'HH:mm'"
                  :value-format="item.valueFormat || 'YYYY-MM-DD'"
                  type="datetime"
                />
              </template>
              <template v-else-if="item.type === 'dateTimeRange'">
                <el-date-picker
                  v-model="searchParams[item.prop]"
                  :date-format="item.dateFormat || 'YYYY-MM-DD'"
                  :disabled-date="item.disabledDate"
                  :start-placeholder="item.startPlaceholder || `${t('请选择开始')}${item.label}`"
                  :end-placeholder="item.endPlaceholder || `${t('请选择结束')}${item.label}`"
                  :format="item.format"
                  :range-separator="item.rangeSeparator || 'To'"
                  :shortcuts="item.shortcuts"
                  :time-format="item.timeFormat || 'HH:mm:ss'"
                  :value-format="item.valueFormat || 'YYYY-MM-DD HH:mm:ss'"
                  type="datetimerange"
                />
              </template>
              <template v-else-if="item.type === 'custom'">
                <slot :name="item.prop" />
              </template>
            </el-form-item>
          </el-col>
          <div class="comList-filter-btn" v-show="props.formItem.length">
            <el-button class="search-btn" type="primary" :loading="loading" @click="searchFun">{{ t("搜索") }}</el-button>
            <el-button v-if="props.formItem.length > 0" class="reset-btn" :loading="loading" @click="resetFun">
              {{ t("重置") }}
            </el-button>
            <el-button v-if="hasExtraFilters" link type="primary" class="collapse-btn" @click="filterCollapsed = !filterCollapsed">
              {{ filterCollapsed ? "展开" : "收起" }}
              <el-icon class="el-icon--right">
                <ArrowDown v-if="filterCollapsed" />
                <ArrowUp v-else />
              </el-icon>
            </el-button>
          </div>
        </el-row>
      </el-form>
    </el-card>
    <!-- 按钮工具栏区域 -->
    <el-card class="btn-container" v-show="tableButtons.length">
      <div class="comList-btn">
        <ComButton :list="tableButtons" :filter-params="searchParams" :checked-list="checkedData" :max-visible="props.maxVisible"></ComButton>
        <slot name="defineButton"></slot>
      </div>
    </el-card>
    <!-- 列表展示区域 -->
    <el-card class="list-container">
      <div class="table-container">
        <ag-table
          @selectRows="selectRowsFn"
          @cellClicked="cellClicked"
          v-loading="loading"
          element-loading-text="Loading..."
          :element-loading-spinner="svg"
          :pageKey="pageKey"
          element-loading-svg-view-box="-10, -10, 50, 50"
          :showRightConfig="true"
          :enableBoxSelect="props.enableBoxSelect"
          v-bind="agGridOptions"
        ></ag-table>
      </div>
      <div class="comList-pagination">
        <div class="comList-total">
          <span>已选：{{ checkedData.length || 0 }}</span>
        </div>
        <div style="display: flex; gap: 20px">
          <span class="comList-total"> 共 {{ pageInfo.total || 0 }}条 </span>
          <el-pagination
            size="small"
            :current-page="pageInfo.pageNum"
            :page-size="pageInfo.pageSize"
            :page-sizes="[50, 100, 200, 500, 1000, 2000, 5000]"
            background
            layout="sizes, prev, pager, next"
            :total="pageInfo.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </el-card>
    <slot />
    <BatchQuery ref="batchQueryRef" @batchParams="batchParams" />
  </div>
</template>

<script lang="ts" setup>
import { ref, withDefaults, defineProps, defineEmits, defineExpose, computed, onMounted, reactive, inject } from "vue";
import { ElInput, ElForm, ElMessage } from "element-plus";
import { MoreFilled, ArrowDown, ArrowUp } from "@element-plus/icons-vue";
import AsyncSelect from "./components/async-select.vue";
import BatchQuery from "./components/batchQuery.vue";
import request from "@/utils/request";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

const router = useRouter();
const { t } = useI18n();
const svg = `
        <path class="path" d="
          M 30 15
          L 28 17
          M 25.61 25.61
          A 15 15, 0, 0, 1, 15 30
          A 15 15, 0, 1, 1, 27.99 7.5
          L 15 15
        " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
      `;

interface PropType {
  formItem: Array<Record<string, any>>;
  rules?: Record<string, any>;
  tableItem?: Array<Record<string, any>>;
  showTenant?: Boolean;
  multipleSelection?: Record<string, any>[];
  buttonItem?: Array<Record<string, any>>;
  selectable?: (row: Record<string, any>, index: number) => boolean;
  dataPro?: any;
  maxVisible?: Number;
  enableBoxSelect?: boolean;
}

const props = withDefaults(defineProps<PropType>(), {
  formItem: () => [],
  tableItem: () => [],
  maxVisible: () => 5,
  buttonItem: () => [],
  rules: () => ({}),
  showTenant: () => true,
  dataPro: () => (pageInfo: Record<string, any>, searchParams: Record<string, any>) => ({
    value1: "默认值1",
    value2: "默认值2",
  }),
  enableBoxSelect: true,
});

const tableButtons = computed(() => {
  // 导出参数做为空校验，外部按钮没传参数，直接取值comList内部数据
  const list = props.buttonItem.map((ele) => {
    if (ele.type == "export" && ele.exportParams) {
      ele.params = () => {
        return {
          pageDomain: {
            pageNum: pageInfo.value.pageNum,
            pageSize: pageInfo.value.pageSize,
          },
          ...searchParams.value,
          ...ele.exportParams(),
        };
      };
    }
    return ele;
  });
  return list;
});

const loading = ref(false);
const emits = defineEmits(["update:multipleSelection", "update:model", "cellClicked", "reset"]);
const checkedData = ref<any>([]);
const selectRowsFn = (list) => {
  checkedData.value = list;
  emits("update:multipleSelection", list);
};
const cellClicked = (p) => {
  emits("cellClicked", p);
};
const batchQueryRef = ref(null);
const formRef = ref<InstanceType<typeof ElForm>>();
const searchParams = ref<any>({});
// 筛选区收缩：默认展开(展示全部)，仅当筛选条件超过一行时出现「展开/收起」
const filterCollapsed = ref(false);
// 第一行能容纳的筛选项数（按 span 累加到 24 计算）
const firstRowCount = computed(() => {
  let sum = 0;
  let count = 0;
  for (const item of props.formItem || []) {
    const span = item.span || 6;
    if (sum + span > 24) break;
    sum += span;
    count++;
  }
  return count;
});
const hasExtraFilters = computed(() => (props.formItem || []).length > firstRowCount.value);
const pageInfo = ref<Record<string, any>>({
  pageNum: 1,
  pageSize: 100,
  total: 0,
});

// const resetItem = (): void => {
//   formRef.value?.resetFields()
//   emits('update:model', {})
// }

const getParams = () => {
  const obj = {
    pageDomain: {
      pageNum: pageInfo.value.pageNum,
      pageSize: pageInfo.value.pageSize,
    },
    ...searchParams.value,
  };
  emits("update:model", obj);
  return obj;
};
// 通用查询接口
const commonQuery = (url: string) => {
  return new Promise((r) => {
    request({
      method: "POST",
      url,
      data: getParams(),
    })
      .then((res: Record<string, any>) => {
        if (res.code == 200) {
          const list = res.data.data || [];
          const total = res.data.total;
          r({ list, total });
        } else {
          ElMessage.error(res.msg);
          r({ list: [], total: 0 });
        }
      })
      .catch(() => {
        r({ list: [], total: 0 });
      })
      .finally(() => {
        loading.value = false;
      });
  });
};

const searchFun = (): void => {
  let getTableObj = null;
  if (props.dataPro === null) {
    agGridOptions.rowData = [];
    pageInfo.value.total = 0;
    return;
  }
  if (typeof props.dataPro === "function") {
    getTableObj = props.dataPro({ ...pageInfo.value }, { ...searchParams.value });
  } else if (typeof props.dataPro === "string") {
    getTableObj = commonQuery(props.dataPro);
  }
  loading.value = true;
  getTableObj
    .then(({ list = [], total = 0 }) => {
      agGridOptions.rowData = list;
      pageInfo.value.total = Number(total);
    })
    .finally(() => {
      loading.value = false;
      checkedData.value = [];
    });
};

const pageKey = ref("");
const getPageKey = () => {
  return router.currentRoute.value.path;
};

onMounted(searchFun);
pageKey.value = getPageKey();
const resetFun = (): void => {
  formRef.value?.resetFields();
  searchParams.value = {};
  emits("reset");
  searchFun();
};

const handleSizeChange = (e: number): void => {
  pageInfo.value.pageSize = e;
  searchFun();
};

const handleCurrentChange = (e: number): void => {
  pageInfo.value.pageNum = e;
  searchFun();
};

const resetSearch = (): void => {
  formRef.value!.resetFields();
  pageInfo.value = {
    pageNum: 1,
    pageSize: 100,
    total: 0,
  };
  searchFun();
};

const formaterInputString = (val: string) => {
  return val.replace(/[\s\r\n，,]+/g, ",");
};

const tenantCb = inject("$tenantInfo") as any;
const getCols = (list) => {
  const tmpList = list.map((o) => {
    const obj = { ...o };
    if ("label" in obj) {
      obj["headerName"] = obj.label;
      delete obj.label;
    }
    if ("prop" in obj) {
      obj["field"] = obj.prop;
      delete obj.prop;
    }
    return obj;
  });
  // tmpList根据local排序，如果没有则不排序默认展示
  const local = JSON.parse(localStorage.getItem("column_config_map"));
  if (local && local[pageKey.value]) {
    tmpList.sort((a, b) => {
      const indexA = local[pageKey.value]?.indexOf(a.field);
      const indexB = local[pageKey.value]?.indexOf(b.field);
      return indexA - indexB;
    });
  }
  return tmpList;
};
const agGridOptions = reactive({
  columnDefs: getCols(props.tableItem),
  rowData: [],
  showTenant: props.showTenant,
});
const batchSearchFun = (targetField: Record<string, any>) => {
  if (!batchQueryRef.value) return;
  batchQueryRef.value?.open(targetField, searchParams.value[targetField.prop]);
};

const batchParams = (val: Record<string, any>) => {
  Object.assign(searchParams.value, val);
  searchFun();
};

const setParams = (val: Record<string, any>) => {
  Object.assign(searchParams.value, val);
};
defineExpose({ pageInfo, resetSearch, searchFun, batchParams, setParams, getParams });
</script>

<style lang="scss" scoped>
.comList-container {
  // height: 100vh;
  height: 100%;
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /* 禁止整个页面滚动 */
  .el-row {
    margin-right: 0px !important;
  }

  .el-col {
    padding-right: 0px !important;
    min-width: 320px;
    max-width: 458px;
  }

  :deep(.el-form-item__label) {
    color: #3f3f3f !important;
  }

  :deep(.filter-area) {
    margin-bottom: 8px;
    user-select: none;
    .el-card__body {
      padding: 10px 12px;

      .el-form {
        .el-form-item {
          margin-bottom: 8px;

          :deep(.el-form-item__content) {
            .el-input {
              .el-input__wrapper {
                .el-input__inner {
                  font-size: 14px;
                  color: #000;

                  &::placeholder {
                    color: #eee;
                  }
                }
              }
            }

            .el-select {
              .el-select__wrapper {
                .el-select__selected-item {
                  .el-select__input {
                    font-size: 14px;
                    color: #000;
                  }
                }

                .el-select__placeholder.is-transparent {
                  font-size: 14px;
                  color: #000;
                }

                .el-select__placeholder {
                  font-size: 14px;
                  color: #000;
                }
              }
            }

            .el-date-editor,
            .el-cascader {
              width: 100%;
            }
          }

          .el-input__icon {
            cursor: pointer;
          }
        }
      }
    }
  }

  .comList-filter-btn {
    margin-left: auto;

    .search-btn,
    .reset-btn {
      font-size: 14px;
      padding: 8px 24px;
    }
  }

  :deep(.btn-container) {
    margin-bottom: 8px;

    .el-card__body {
      padding: 8px 12px;

      .comList-btn {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .el-button {
          color: #ffffff;
        }
      }
    }
  }

  :deep(.list-container) {
    flex: 1;
    /* 占据剩余空间 */
    display: flex;
    flex-direction: column;
    overflow: hidden;
    /* 隐藏卡片溢出 */
    min-height: 0;

    /* 关键：允许flex item收缩 */
    .el-card__body {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 0;
      height: 100% !important;
    }
  }

  .table-container {
    flex: 1;
    padding: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .comList-pagination {
    margin-top: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 12px;
    flex-shrink: 0;
    border-top: 1.5px solid #dedede;

    .comList-total {
      font-size: 14px;
      letter-spacing: 1px;
      color: #000;
      display: flex;
      align-items: center;
      gap: 30px;
    }
  }
}
</style>
